import { MapPin } from 'lucide-react'

export const RetailAccessGuidelines = () => (
  <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
    <div className="flex items-start gap-3">
      <MapPin className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
      <div className="text-sm text-blue-800 dark:text-blue-200">
        <p className="font-medium mb-1">Access control guidelines</p>
        <ul className="space-y-1 text-blue-700 dark:text-blue-300">
          <li>System Operators automatically have access to all resources</li>
          <li>
            Selecting a single system enables fine-grained access to DBAs, Districts, and Locations
          </li>
          <li>
            Selecting multiple systems grants access to ALL DBAs, Districts, and Locations for each
            system
          </li>
          <li>Check &quot;Grant access to all&quot; to bypass specific assignments</li>
        </ul>
      </div>
    </div>
  </div>
)
